import { Box, Image } from '@chakra-ui/react';
import React from 'react';

export default function Logo() {
  const appDomain = localStorage.getItem('domainName');
  

  return (
    <Box className='header-logo'>
      <Image
        className='desktop-logo'
        src={appDomain === 'myffl.com' ?
          '//assets.masterffl.com/public/defaultStoreLogo/myffl-logo.png'
          :'//assets.masterffl.com/public/defaultStoreLogo/ffl-full-logo.svg'
        }
      />
      <Image
        className='mobile-logo'
        src='/images/ui/ffl_White.png'
      />
    </Box>
  );
}
